import React from 'react';

const Support = () => {
  return <h1>Support Page</h1>;
};

export default Support;
